const cartPop = new Vue({
  data: () => {
    return {
      adapter: null,
      storage: null,
      shopify: null,
      localKey: "cartItems",
      cartList: [],
      shopifyCartData: {
        items_subtotal_price: 0,
        total_discount: 0,
        total_price: 0,
      },
      showPop: false,
      loginFlag: false,
      freeStr: "Free",
    };
  },
  async created() {
    const path = window.location.pathname;
    if (path.includes("/cart")) return;
    this.loginFlag = theme.isLogin();
    this.adapter = new StorageAdapter();
    this.storage = new LocalStorage();
    this.shopify = new ShopifyRelatedV2();
    await this.init();
  },
  computed: {
    itemCount() {
      if (!this.cartList || this.cartList?.length == 0) return 0;
      let count = 0;
      for (let item of this.cartList) {
        count += Number(item.quantity);
      }
      return count || 0;
    },
    itemCountStr() {
      return this.itemCount > 99 ? "99+" : this.itemCount;
    },
    productMinQuantity() {
      const stats = {};

      if (!this.cartList || this.cartList?.length == 0) return stats;
      this.cartList.forEach((item) => {
        const productId = item.product_id;
        if (!stats[productId]) {
          stats[productId] = {
            quantity: 0,
            minQuantity: item.min_quantity || 1,
          };
        }
        if (item.checked) {
          stats[productId].quantity += Number(item.quantity);
        }
      });
      return stats;
    },
  },
  methods: {
    reportAddCart() {
      _paq.push([
        "trackEcommerceCartUpdate",
        Number(this.handlePrice(this.shopifyCartData.total_price)),
      ]);
    },
    async init() {
      const localData = await this.storage.read(this.localKey);
      this.cartList = await this.adapter.read(this.localKey);
      await this.adapter.storageCount(this.cartList);
      // 登陆时判断本地是否存有数据，如果有数据，上报到接口，并删除本地数据
      if (this.loginFlag && localData.length > 0) {
        const responseData = await this.adapter.create({
          key: this.localKey,
          value: localData,
        });
        if (responseData) {
          await this.storage.clear(this.localKey);
          // await this.shopify.clear();
        }
      }
      await this.getCartList();
    },
    // 获取购物车数据
    async getCartList() {
      this.cartList = await this.adapter.read(this.localKey);
      this.shopifyCartData = { items_subtotal_price: 0 };
      if (!this.cartList || this.cartList?.length == 0) return;
      this.shopifyCartData = await this.shopify.create(this.cartList);
      this.reportAddCart();
      this.handleDataList();
    },
    // 更新购物车数量
    async updateCart(item) {
      response = await this.adapter.update({ key: this.localKey, value: item });
      if (response) {
        this.cartList = response;
        this.judgeMinQuantity();
        this.shopifyCartData = await this.shopify.create(this.cartList);
        this.handleDataList();
      }
    },
    // 将shopify数据返回的价格赋给接口数据
    handleDataList() {
      if (!this.shopifyCartData?.items && !this.shopifyCartData.items.length)
        return;
      for (let item of this.shopifyCartData?.items) {
        for (let cartItem of this.cartList) {
          if (cartItem.variant_id == item.variant_id) {
            cartItem.original_price = item.original_price;
            cartItem.final_price = item.final_price;
            cartItem.line_price = item.line_price;
            cartItem.final_line_price = item.final_line_price;
            break;
          }
        }
      }

      if (!this.cartList || this.cartList?.length == 0) return;
      for (let item of this.cartList) {
        if (!item.checked) {
          item.final_price = item.final_price;
          item.original_price = item.final_price;
        }
      }
    },
    // 处理图片地址
    handleImg(img) {
      if (img.indexOf("width=") == -1 && img.indexOf("?") == -1) {
        if (img.indexOf("?") != -1) {
          return img + "&width=100";
        }
        return img + "?width=100";
      }
      return img;
    },
    // 处理产品重量
    handleWeight(weight) {
      if (weight) return (weight / 1000).toFixed(3);
      return `0.000`;
    },
    // 处理产品价格
    handlePrice(price) {
      return parseFloat((price / 100).toFixed(2));
    },
    // 处理变体名称显示(去掉Free)
    handleVariantName(name) {
      if (!name) return "";
      if (name.indexOf(this.freeStr) != -1) {
        return name.split(this.freeStr)[1];
      }
      return name;
    },
    // 数量减少
    duceQuantity(item) {
      const step = item.min_batch || 1;
      const newQuantity = item.quantity - step;
      if (newQuantity < step) return;
      item.quantity = Math.max(step, newQuantity);
      this.updateCart(item);
    },
    // 数量增加
    addQuantity(item) {
      const step = item.min_batch || 1;
      const newQuantity = item.quantity + step;
      item.quantity = Math.min(99999, newQuantity);
      this.updateCart(item);
    },
    // 输入数量
    inputQuantity(item) {
      const step = item.min_batch || 1;
      let inputQuantity = parseInt(item.quantity) || 0;
      if (inputQuantity <= 0) {
        item.quantity = step;
      } else {
        // 将输入的数量调整为最接近的步长倍数（向下取整）
        let adjustedQuantity = Math.floor(inputQuantity / step) * step;
        adjustedQuantity = adjustedQuantity == 0 ? step : adjustedQuantity;
        // 确保不超过库存限制
        item.quantity = Math.min(99999, adjustedQuantity);
      }
      this.updateCart(item);
    },
    // 防抖函数
    debounce(func, delay) {
      let timer;
      return function (...args) {
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(() => {
          func.apply(this, args);
        }, delay);
      };
    },
    // 鼠标移入，打开购物车弹窗
    openPop() {
      if (this.cartList?.length > 0) {
        this.showPop = true;
      }
    },
    // 鼠标移开，关闭购物车弹窗
    closePop() {
      const elementB = document.querySelector("#headerCart .cartHoverBox");
      var timer = setTimeout(() => {
        if (!elementB?.matches(":hover")) {
          this.showPop = false;
        }
        clearTimeout(timer);
      }, 2000);
    },
    async judgeMinQuantity() {
      const list = this.showFreeShippingList
        ? this.freeShippingList
        : this.cartList;
      // 先重置所有项的disabled状态（避免误判）
      list.forEach((item) => {
        this.$set(item, "disabled", false);
      });
      // 检查每个勾选项是否满足所属产品的最小数量要求
      for (const item of list) {
        if (item.checked) {
          const productStats = this.productMinQuantity[item.product_id];
          // 若产品总数量 < 最小数量要求，设置disabled为true
          if (
            productStats &&
            productStats.quantity < productStats.minQuantity
          ) {
            this.$set(item, "disabled", true);
          }
        }
      }
    },
  },
  template: `
    <div class="wbhcart relative" id="headerCart" @mouseenter="openPop" @mouseleave="closePop">
      <a href="/cart" id="cart-icon-bubble" class="focus-inset underline-remove leftcart flex">
        <span class="svgbg">
          <svg t="1733309394601" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="33167" width="64" height="64">
            <path d="M246.4 912a2.1 2.1 0 1 0 134.4 0 2.1 2.1 0 1 0-134.4 0Z" p-id="33168" fill="#000000"></path>
            <path d="M716.8 912a2.1 2.1 0 1 0 134.4 0 2.1 2.1 0 1 0-134.4 0Z" p-id="33169" fill="#000000"></path>
            <path d="M905.6 764.8l-537.6 0c-28.8 0-57.6-25.6-64-54.4l-96-566.4c-9.6-54.4-60.8-96-115.2-96l-22.4 0c-12.8 0-25.6 12.8-25.6 25.6 0 12.8 12.8 25.6 25.6 25.6l22.4 0c28.8 0 57.6 25.6 64 54.4l96 566.4c9.6 54.4 60.8 96 115.2 96l537.6 0c12.8 0 25.6-12.8 25.6-25.6C931.2 777.6 921.6 764.8 905.6 764.8z" p-id="33170" fill="#000000"></path><path d="M880 179.2l-572.8 0c-12.8 0-25.6 12.8-25.6 25.6 0 12.8 12.8 25.6 25.6 25.6l572.8 0c25.6 0 38.4 16 32 41.6l-70.4 281.6c-6.4 32-41.6 57.6-73.6 60.8l-396.8 28.8c-12.8 0-25.6 12.8-22.4 28.8 0 12.8 12.8 25.6 28.8 22.4l396.8-28.8c54.4-3.2 105.6-48 118.4-99.2l70.4-281.6C976 230.4 937.6 179.2 880 179.2z" p-id="33171" fill="#000000"></path>
          </svg>
        </span>
        <span class="text-left wbhuserleft">
          <span>Cart</span>
          <strong class="center notranslate">({{ itemCountStr }})</strong>
        </span>
      </a>
      <div class="cartHoverBox" v-if="showPop" @mouseleave="showPop=false">
        <div class="boxContent">
          <div class="boxtop">
            Cart ({{ itemCount }})
          </div>
          <div class="box-item">
            <div class="cart-item" role="row" v-for="item in cartList" :key="item.id">
              <div class="cart-item-left">
                <a
                  :href="item.url"
                  class="cart-item__link"
                  tabindex="-1"
                  aria-hidden="true"
                  target="_blank"
                >
                  <img
                    class="cart-item__image"
                    :src="handleImg(item.featured_image?.url)"
                    alt=""
                    loading="lazy"
                    width="100"
                    height="100"
                  >
                </a>
              </div>
              <div class="cart-item-right">
                <a
                  :href="item.url"
                  target="_blank"
                  class="cart-item__name h4 break"
                >
                  {{ item.product_title }}
                </a>
                <div class="product-option options">
                  <span v-for="(option, index) in item.variant_options" :key="index">{{ handleVariantName(option.value || option) }}<span v-if="index<item.variant_options.length-1"> | </span></span>
                </div>

                <div class="flex align-items-center">
                  <div class="cart-item__discounted-prices item-price-wrapper price-inner" v-if="item.checked">
                    <span class="product-option price-original notranslate">
                      {{ theme.formatPrice(item.final_line_price) }}
                    </span>
                    <span class="product-option cart-item__old-price notranslate" v-if="item.line_price>item.final_line_price">
                      {{ theme.formatPrice(item.line_price) }}
                    </span>
                  </div>
                  <div class="cart-item__discounted-prices item-price-wrapper price-inner" v-else>
                    <span class="product-option price-original notranslate">
                      {{ theme.formatPrice(theme.multiply(theme.convertCurrency(item.final_price || item.original_price, 'usdToSet'), item.quantity)) }}
                    </span>
                  </div>
                </div>
                <div class="flex align-items-center justify-space-between">
                  <div class="flex item-weight-wrapper align-items-center">
                    Weight: <span class="notranslate">{{ handleWeight(item.weight) }}kg</span>
                  </div>
                  <div class="cart-item__quantity-wrapper">
                    <quantity-input class="quantity cart-quantity">
                      <button class="quantity__button no-js-hidden" :class="item.quantity == (item.min_batch || 1) ? 'disabled' : ''" @click="duceQuantity(item)" name="minus" type="button">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden="true"
                          focusable="false"
                          class="icon icon-minus"
                          fill="none"
                          viewBox="0 0 10 2"
                        >
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path>
                        </svg>
                      </button>
                      <input
                        class="quantity__input quantity__input-"
                        type="number"
                        v-model="item.quantity"
                        @change="inputQuantity(item)"
                      >
                      <button class="quantity__button no-js-hidden" @click="addQuantity(item)" name="plus" type="button">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden="true"
                          focusable="false"
                          class="icon icon-plus"
                          fill="none"
                          viewBox="0 0 10 10"
                        >
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>
                        </svg>
                      </button>
                    </quantity-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="boxfooter">
            <div class="cartTotal">
              <div class="cartTotal" role="status">
                <p class="product-option price-original trans-money">
                  <span>Total:</span>
                  <span class="notranslate" id="items-total">{{ theme.formatPrice(shopifyCartData?.total_price) }}</span>
                </p>
              </div>
            </div>
            <a href="/cart" style="width: 100%; cursor: pointer;" target="_blank"><button class="toCart">To Cart</button></a>
          </div>
        </div>
        <div class="decorate"></div>
      </div>
    </div>
  `,
});

cartPop.$mount("#cart-pop");
